
import { handleAxiosException } from '@/api'
import {
  myRegistrationApi,
  RegistrationHorseRequest,
  RegistrationHorseValidationRequest,
  RegistrationOwnerRequest,
} from '@/api/auth/myHorseRegistration'
import { headerApi, HeaderDto } from '@/api/header'
import { horseApi, HorseFilter, MinimalHorseDto } from '@/api/horse'
import { Horse, ifceApi } from '@/api/ifce'
import { lotSellerApi, LotSellerDto } from '@/api/lotSeller'
import { placeToVisitApi, PlaceToVisitDto } from '@/api/placeToVisit'
import DatePicker from '@/components/shared/DatePicker.vue'
import KAutocomplete from '@/components/shared/KAutocomplete.vue'
import KCombobox from '@/components/shared/KCombobox.vue'
import { GetSaleDto } from '@/dtos'
import { formatAddress } from '@/utils/addresses'
import { availableBreeds, availableTrotBreeds } from '@/utils/breeds'
import countries, { getCountryLabel } from '@/utils/countries'
import { formatBetween } from '@/utils/dates'
import genders from '@/utils/genders'
import horseStatuses from '@/utils/horseStatus'
import { HorseType, horseTypesGalop, horseTypesTrot } from '@/utils/horseType'
import protrusionFormulas from '@/utils/protrusionFormula'
import protrusionRoles from '@/utils/etalonnierPayment'
import { availableRobes } from '@/utils/robes'
import { isRequired, isRequiredGenerator, validMicrochipIdRule, validSireIdRule } from '@/utils/rules'
import { AxiosResponse } from 'axios'
import { countBy, debounce, Dictionary } from 'lodash'
import Vue from 'vue'
import HeaderDialog from '../header/HeaderDialog.vue'
import LotSellerDialog from '../lot-seller/LotSellerDialog.vue'
import PlaceToVisitDialog from '../place-to-visit/PlaceToVisitDialog.vue'
import RegistrationStepper from './RegistrationStepper.vue'

let idAutoIncrement = 0

const defaultHorseRequest: RegistrationHorseRequest = {
  birthCountry: '',
  birthday: '',
  deathday: '',
  breed: '',
  gender: '',
  motherBirthyear: '',
  motherFatherName: '',
  motherName: '',
  fatherMotherBirthyear: '',
  fatherMotherFatherName: '',
  fatherMotherName: '',
  fatherBirthyear: '',
  fatherFatherName: '',
  fatherName: '',
  robe: '',
  type: undefined,
  microchipId: '',
  name: '',
  sireId: '',
  status: undefined,
  stallionPart: undefined,
  stallionPartNumber: undefined,
  protrusionFormula: undefined,
  protrusionDate: undefined,
  stallion: undefined,
  assimile: false,
  foreignRegime: false,
  associationContract: false,
  rentalContract: false,
  cartesSaillies: process.env.VUE_APP_IS_TROT ? 0 : undefined,
  etalonnierPaid: false,
  etalonnierAmount: undefined,
  etalonnierPayment: 'SELLER',
  etalonnierLabel: '',
}

export default Vue.extend({
  components: { KCombobox, DatePicker, KAutocomplete, HeaderDialog, PlaceToVisitDialog, RegistrationStepper, LotSellerDialog },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
    sale: {
      required: true,
      type: Object as () => GetSaleDto,
    },
  },
  data() {
    return {
      valid: true,
      saving: false,
      error: '',
      readOnly: false,
      horse: { ...defaultHorseRequest } as RegistrationHorseRequest,
      disabledAdditionalInfos: false,
      showMore: true,
      robes: availableRobes,
      itemsHorse: [] as Horse[] | undefined,
      genders,
      countries,
      horseTypes: process.env.VUE_APP_IS_TROT ? horseTypesTrot : horseTypesGalop,
      horseStatuses,
      protrusionFormulas,
      protrusionRoles,
      horseTosend: { } as RegistrationHorseValidationRequest,
      breeds: process.env.VUE_APP_IS_TROT ? availableTrotBreeds : availableBreeds,
      sireMenu: {
        loading: false,
        horse: undefined as Horse | undefined,
        debounce: debounce((callback: (value: string) => void, value: string) => {
          callback(value)
        }, 500),
        error: undefined as string | undefined,
      },
      microchipMenu: {
        loading: false,
        horse: undefined as Horse | undefined,
        debounce: debounce((callback: (value: string) => void, value: string) => {
          callback(value)
        }, 500),
        error: undefined as string | undefined,
        warning: undefined as string | undefined,
        success: undefined as string | undefined,
      },

      header: undefined as number|undefined,
      newHeaderDialog: false,
      createdHeader: undefined as HeaderDto|undefined,

      placeToVisit: 0 as number,
      newPlaceToVisitDialog: false,
      createdPlaceToVisit: undefined as PlaceToVisitDto|undefined,

      owners: [] as RegistrationOwnerRequest[],
      ownerKeys: [] as number[],
      newLotSellerDialog: false,

      snackbarSuccessRegistration: {
        active: false,
        message: '',
      },
      isTrot: !!process.env.VUE_APP_IS_TROT,
    }
  },
  methods: {
    getCountryLabel,
    formatNamePlaceToVisit(placeToVisit: PlaceToVisitDto) {
      return placeToVisit.name ? placeToVisit.name : placeToVisit.fullName
    },
    formatAddress,
    formatHorse(h: MinimalHorseDto) {
      if (h) {
        return `${h.name} - ${h.birthday.slice(0, 4)} (${h.father?.name})`
      } else {
        return ''
      }
    },
    validSireIdRule,
    isRequired,
    isRequiredGenerator,
    validMicrochipIdRule,
    formatBetween,
    onMicrochipIdUpdate(text: string) {
      this.horse.microchipId = text
      this.microchipMenu.error = undefined
      if (!text) {
        this.microchipMenu.loading = false
      } else if (text && this.validMicrochipIdRule(text) === true) {
        this.microchipMenu.loading = true
        this.microchipMenu.debounce(this.queryHorseByMicrochipId, text)
      }
    },
    async queryHorseByMicrochipId(microchipId: string) {
      try {
        this.microchipMenu.warning = ''
        this.microchipMenu.success = this.$t('success.micro_id_success') as string
        this.microchipMenu.horse = await ifceApi.findByMicrochipOnApi(microchipId)
        this.microchipMenu.loading = false
        this.error = ''
        if (this.checkHorseCompatibleToSale()) {
          const typeTmp = this.horse.type
          this.horse = { ...defaultHorseRequest } as RegistrationHorseRequest
          this.horse.type = typeTmp
          this.fillField(this.microchipMenu.horse)
        } else {
          this.microchipMenu.error = this.$t('error.micro_id') as string
        }
      } catch (e) {
        this.microchipMenu.loading = false
        this.microchipMenu.warning = this.$t('error.micro_id_not_found') as string
      }
    },
    onSireIdUpdate(text: string) {
      this.sireMenu.error = undefined
      if (!text) {
        this.sireMenu.loading = false
      } else if (text && validSireIdRule(text) === true) {
        this.horse.sireId = text.toUpperCase()
        this.sireMenu.loading = true
        this.sireMenu.debounce(this.queryHorseBySireId, text)
      } else {
        this.horse.sireId = text.toUpperCase()
      }
    },
    async queryHorseByName(name: string) {
      this.horse.name = name
      if (name.length >= 3) {
        this.error = ''
        const page = { page: 0, size: 20, sort: ['birthday,DESC', 'name,ASC'] }
        let filter = {} as HorseFilter
        if (this.sale.type === 'STORE') {
          filter = { year: [new Date().getFullYear() - 2, new Date().getFullYear() - 3] }
        } else {
          switch (this.horse.type) {
            case 'FOAL':
              filter = { year: new Date().getFullYear() }
              break
            case 'YEARLING':
              filter = { year: new Date().getFullYear() - 1 }
              break
            case 'YEAR2':
              filter = { year: new Date().getFullYear() - 2 }
              break
            case 'STALLION':
              filter = { gender: ['MALE', 'HONGRE'] }
              break
            case 'MAIDEN':
              filter = { gender: 'FEMELLE' }
              break
            case 'MARE':
              filter = { gender: 'FEMELLE' }
              break
            default:
              break
          }
        }
        return (await horseApi.getAll({ name, ...filter }, page)).content
      } else {
        return []
      }
    },
    // eslint-disable-next-line consistent-return
    checkHorseCompatibleToSale(): boolean | undefined {
      let horse
      let typeSale
      if (this.sireMenu.horse) {
        horse = this.sireMenu.horse
      } else if (this.microchipMenu.horse) {
        horse = this.microchipMenu.horse
      }
      if (horse && this.sale.type !== 'MIXTE') {
        typeSale = this.sale.type
      } else if (horse && this.horse.type) {
        typeSale = this.horse.type
      }
      if (typeSale && horse) {
        switch (typeSale) {
          case 'YEARLING': {
            const birth = new Date(horse.birthday)
            const saleStartDate = new Date(this.sale.startDate)
            const diff = saleStartDate.getFullYear() - birth.getFullYear()

            return diff === 1
          }
          case 'FOAL': {
            const birth = new Date(horse.birthday)
            const saleStartDate = new Date(this.sale.startDate)
            const diff = saleStartDate.getFullYear() - birth.getFullYear()
            return diff < 1
          }
          case 'YEAR2': {
            const birth = new Date(horse.birthday)
            const saleStartDate = new Date(this.sale.startDate)
            const diff = saleStartDate.getFullYear() - birth.getFullYear()
            return diff === 2
          }
          case 'STORE': {
            const birth = new Date(horse.birthday)
            const saleStartDate = new Date(this.sale.startDate)
            const diff = saleStartDate.getFullYear() - birth.getFullYear()
            return diff >= 2 && diff <= 3
          }
          case 'CAE': {
            const birth = new Date(horse.birthday)
            const saleStartDate = new Date(this.sale.startDate)
            const diff = saleStartDate.getFullYear() - birth.getFullYear()
            return diff >= 2
          }
          case 'STALLION':
            return horse.gender === 'MALE' || horse.gender === 'HONGRE'
          case 'MAIDEN':
            return horse.gender === 'FEMELLE'
          case 'MARE':
            return horse.gender === 'FEMELLE'
          default: {
            return true
          }
        }
      }
    },
    async queryHorseBySireId(sireId: string) {
      try {
        this.sireMenu.horse = await ifceApi.findBySireOnApi(sireId)
        this.sireMenu.loading = false
        if (this.checkHorseCompatibleToSale()) {
          const typeTmp = this.horse.type
          this.horse = { ...defaultHorseRequest }
          this.horse.type = typeTmp

          if (this.sireMenu.horse.name === 'N.') {
            const motherName = this.sireMenu.horse.mother?.name
            const birthYear = this.sireMenu.horse.birthday.split('-')[0]
            if (motherName && birthYear) {
              const formattedMotherName = motherName.charAt(0).toUpperCase() + motherName.slice(1).toLowerCase()
              this.sireMenu.horse.name = `N(${formattedMotherName} ${birthYear})`
            }
          }

          this.fillField(this.sireMenu.horse)
        } else {
          this.sireMenu.error = this.$t('error.sire_id') as string
        }
      } catch (e) {
        this.sireMenu.loading = false
        this.sireMenu.error = this.$t('error.sire_id_not_found') as string
      }
    },
    fillField(horse: Horse) {
      this.showMore = true
      this.horse = {
        name: horse.name !== 'N.' ? horse.name : '',
        birthday: horse.birthday,
        deathday: horse.deathday ?? '',
        birthCountry: horse.birthCountry,
        sireId: horse.sireId,
        robe: horse.robe,
        breed: horse.breed,
        motherName: horse.mother?.name,
        motherBirthyear: horse.mother?.birthday?.slice(0, 4),
        motherFatherName: horse.mother?.father?.name,
        fatherName: horse.father?.name,
        fatherBirthyear: horse.father?.birthday?.slice(0, 4),
        fatherFatherName: horse.father?.father?.name,
        fatherMotherName: horse.mother?.father?.name,
        fatherMotherBirthyear: horse.mother?.father?.birthday?.slice(0, 4),
        fatherMotherFatherName: horse.mother?.father?.father?.name,
        gender: horse.gender,
        microchipId: horse.microchipId,
        type: this.horse.type,
        status: undefined,
        stallionPart: undefined,
        stallionPartNumber: undefined,
        protrusionFormula: undefined,
        protrusionDate: undefined,
        stallion: undefined,
        assimile: false,
        foreignRegime: false,
        associationContract: false,
        rentalContract: false,
      }
    },
    fillFieldByName(horse: Horse) {
      if (horse) {
        this.showMore = true
        this.horse = {
          name: horse.name,
          birthday: horse.birthday,
          deathday: horse.deathday ?? '',
          birthCountry: horse.birthCountry,
          sireId: horse.sireId,
          robe: horse.robe,
          breed: horse.breed,
          motherName: horse.mother?.name,
          motherBirthyear: horse.mother?.birthday?.slice(0, 4),
          motherFatherName: horse.mother?.father?.name,
          fatherName: horse.father?.name,
          fatherBirthyear: horse.father?.birthday?.slice(0, 4),
          fatherFatherName: horse.father?.father?.name,
          fatherMotherName: horse.mother?.father?.name,
          fatherMotherBirthyear: horse.mother?.father?.birthday?.slice(0, 4),
          fatherMotherFatherName: horse.mother?.father?.father?.name,
          gender: horse.gender,
          microchipId: horse.microchipId,
          type: this.horse.type,
          status: undefined,
          stallionPart: undefined,
          stallionPartNumber: undefined,
          protrusionFormula: undefined,
          protrusionDate: undefined,
          stallion: undefined,
          assimile: false,
          foreignRegime: false,
          associationContract: false,
          rentalContract: false,
        }
      }
    },
    fillParent(horse: MinimalHorseDto | string, target: string) {
      debugger
      if (typeof horse === 'string') {
        Vue.set(this.horse, `${target}Name`, horse)
      } else if (horse) {
        Vue.set(this.horse, `${target}Name`, horse.name)
        Vue.set(this.horse, `${target}Birthyear`, horse.birthday.slice(0, 4))
        Vue.set(this.horse, `${target}FatherName`, horse.father?.name)
      }
    },
    async save() {
      if (this.showMore && (this.$refs.form as HTMLFormElement).validate()) {
        this.saving = true
        this.error = ''
        if (this.sale.type !== 'MIXTE') {
          this.horse.type = this.sale.type as HorseType
        }
        try {
          this.horseTosend = {
            ...this.horse,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            headerId: this.header!,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            placeToVisitId: this.placeToVisit,
            owners: this.owners,
          }
          await myRegistrationApi.register(this.sale.id, this.horseTosend, this.$route.query.token as string|undefined)

          if (this.$route.query.token) {
            window.location.href = '/vente/inscription'
          } else {
            this.$emit('success', this.horse)
          }
        } catch (err) {
          this.error = this.$t(handleAxiosException(err, (r: AxiosResponse) => r.data?.message ?? 'form.error.global_error')) as string
        } finally {
          this.saving = false
        }
      }
    },
    async queryFather(value: string) {
      if (value && value.length >= 3) {
        return horseApi.get(value, ['MALE', 'HONGRE'])
      } else {
        return []
      }
    },
    async queryMother(value: string) {
      if (value && value.length >= 3) {
        return horseApi.get(value, ['FEMELLE'])
      } else {
        return []
      }
    },
    async queryStallion(name: string) {
      if (name != null) {
        const page = { page: 0, size: 20, sort: [] }
        return (await horseApi.getAll({ name, gender: ['MALE', 'HONGRE'] }, page)).content
      } else {
        return []
      }
    },
    close() {
      this.$emit('input', false)
    },

    async callbackHeaders(filter: string) {
      return (await headerApi.getAllHeaders({ size: 20, name: filter })).content
    },
    onSuccessSaveHeader(header: HeaderDto) {
      this.newHeaderDialog = false
      this.header = header.id
      this.createdHeader = header
    },

    async callbackPlaceToVisits(filter: string) {
      return (await placeToVisitApi.getAllPlacesToVisit({ size: 20, name: filter })).content
    },
    onSuccessSavePlaceToVisit(placeToVisit: PlaceToVisitDto) {
      this.newPlaceToVisitDialog = false
      this.placeToVisit = placeToVisit.id
      this.createdPlaceToVisit = placeToVisit
    },

    async callbackOwners(filter: string) {
      return (await lotSellerApi.getAllLotSellers({ size: 20, name: filter })).content
    },

    removeOwner(i: number) {
      this.owners.splice(i, 1)
      this.ownerKeys.splice(i, 1)
    },
    addOwner() {
      this.owners.push({ lotSellerId: 0, part: 100 })
      // eslint-disable-next-line no-plusplus
      this.ownerKeys.push(idAutoIncrement++)
    },
    createOwner() {
      this.newLotSellerDialog = true
    },
    confirmCreateOwner(p: LotSellerDto, id: number) {
      this.newLotSellerDialog = false
      this.snackbarSuccessRegistration = {
        active: true,
        message: this.$t('success.save', { name: p.name ?? `${p.firstname} ${p.name}` }) as string,
      }
      this.owners.push({ lotSellerId: id, part: 0 })
      // eslint-disable-next-line no-plusplus
      this.ownerKeys.push(idAutoIncrement++)
    },
    calculateParts() {
      switch (this.owners.length) {
        case 1:
          this.owners[0].part = 100
          break
        case 2:
          this.owners[0].part = 50
          this.owners[1].part = 50
          break
        case 3:
          this.owners[0].part = 50
          this.owners[1].part = 25
          this.owners[2].part = 25
          break
        case 4:
          this.owners[0].part = 50
          this.owners[1].part = 20
          this.owners[2].part = 20
          this.owners[3].part = 10
          break
        default:
      }
    },
    createPlaceToVisit() {
      this.newPlaceToVisitDialog = true
    },
    createHeader() {
      this.newHeaderDialog = true
    },
    showMoreInfoForHorse() {
      this.showMore = true
    },
  },
  computed: {
    ruleAllPartBelow100(): undefined | string {
      if (this.owners.reduce((p, c) => p + c.part, 0) === 100) {
        return undefined
      } else {
        return 'La somme totale des parts doit être égale à 100%'
      }
    },
    isPercentageStrictPositive() {
      return (v: number) => v >= 1 && v <= 100 || 'La valeur doit être comprise entre 1 et 100'
    },
    ownerCount(): Dictionary<number> {
      return countBy(this.owners, (el) => el.lotSellerId)
    },
    visitRule() {
      if (this.horse.type === 'YEARLING' || this.horse.type === 'STORE2' || this.horse.type === 'STORE3' || this.horse.type === 'MARE' || this.horse.type === 'FOAL' || this.horse.type === 'MAIDEN' || this.horse.type === 'STALLION') {
        return [isRequiredGenerator(this.$t('form.place-to-visit.required').toString())]
      } else {
        return []
      }
    },
    openHorsesTypes() {
      let types = [] as HorseType[]
      if (this.sale.subscriptions.length > 0) {
        const today = new Date()
        this.sale.subscriptions.forEach(s => {
          const firstDay = new Date(s.startDate)
          const lastDay = new Date(s.endDate)
          lastDay.setDate(lastDay.getDate() + 1)
          if (today >= firstDay && today <= lastDay || this.sale.registrationTicket?.id) {
            switch (s.type) {
              case 'ELEVAGE':
                types = types.concat(['MARE', 'MAIDEN', 'FOAL'])
                break
              case 'STORE23':
                types = types.concat(['STORE2', 'STORE3'])
                break
              case 'CAE':
                types.push('CAE')
                break
              case 'DEUXANS':
                types.push('YEAR2')
                break
              case 'YEARLING':
                types.push('YEARLING')
                break
              case 'ETALON':
                types = types.concat(['STALLION'])
                break
              case 'PART_ETALON':
                types = types.concat(['STALLION_PART', 'BREEDING_RIGHT'])
                break
              case 'MIXTE':
                types = types.concat(['MARE', 'MAIDEN', 'FOAL', 'YEARLING', 'CAE', 'YEAR2', 'STALLION', 'STALLION_PART', 'BREEDING_RIGHT'])
                break
              default:
            }
          }
        })
      } else {
        types = this.horseTypes.map(e => e.value)
      }
      return types.map(el => ({ key: el, label: this.$t(`lot.type.${el.toLowerCase()}`) }))
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.horse = { ...defaultHorseRequest }
        // eslint-disable-next-line no-unused-expressions
        ;(this.$refs.form as HTMLFormElement | undefined)?.resetValidation()
        this.valid = true
        this.showMore = true
        this.error = ''
        this.header = undefined
        this.createdHeader = undefined
        this.placeToVisit = 0
        this.createdPlaceToVisit = undefined
        this.owners = []
        if (this.sale.type !== 'MIXTE') {
          this.horse.type = this.sale.type as HorseType
        }
      }
    },
  },
})
